import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  RecurringSpendingFirestoreResponse,
  CreateRecurringSpendingDto,
  UpdateRecurringSpendingDto,
  DeleteRecurringSpendingResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const RecurringSpendingResponseSchema = RecurringSpendingFirestoreResponse;
export const CreateRecurringSpendingSchema = CreateRecurringSpendingDto;
export const UpdateRecurringSpendingSchema = UpdateRecurringSpendingDto;

// ====== Type Exports ======
export type RecurringSpendingResponse = z.infer<typeof RecurringSpendingFirestoreResponse>;
export type CreateRecurringSpending = z.infer<typeof CreateRecurringSpendingDto>;
export type UpdateRecurringSpending = z.infer<typeof UpdateRecurringSpendingDto>;

// API factory function
export function createRecurringSpendingsApi(client: TypedApiClient) {
  return {
    getRecurringSpendings: (): Promise<RecurringSpendingResponse[]> => {
      return client.get('/recurring-spendings', {
        responseSchema: z.array(RecurringSpendingFirestoreResponse),
      });
    },

    getRecurringSpendingById: (id: string): Promise<RecurringSpendingResponse> => {
      return client.get(apiPath`/recurring-spendings/${id}`, {
        responseSchema: RecurringSpendingFirestoreResponse,
      });
    },

    createRecurringSpending: (data: CreateRecurringSpending): Promise<RecurringSpendingResponse> => {
      return client.post('/recurring-spendings', {
        data,
        requestSchema: CreateRecurringSpendingDto,
        responseSchema: RecurringSpendingFirestoreResponse,
      });
    },

    updateRecurringSpending: (id: string, data: UpdateRecurringSpending): Promise<RecurringSpendingResponse> => {
      return client.patch(apiPath`/recurring-spendings/${id}`, {
        data,
        requestSchema: UpdateRecurringSpendingDto,
        responseSchema: RecurringSpendingFirestoreResponse,
      });
    },

    deleteRecurringSpending: (id: string): Promise<z.infer<typeof DeleteRecurringSpendingResponseDto>> => {
      return client.delete(apiPath`/recurring-spendings/${id}`, {
        responseSchema: DeleteRecurringSpendingResponseDto,
      });
    },
  };
}
